export const CONFIG = {
    URL: 'https://proxyhouse.space',
    NAME: 'ProxyHouse',
    MAIL: 'proxyhouse.help@gmail.com'
}